export const columns = [
  {
    title: 'Thứ tự',
    key: 'order',
    width: 100,
    sorter: true,
    dataIndex: 'order',
  },
  {
    title: 'Tên cấp đánh giá',
    key: 'name',
    sorter: true,
    dataIndex: 'name',
  },
  {
    title: 'Chức năng',
    key: 'functionName',
    sorter: true,
    dataIndex: 'functionName',
  },
  {
    title: 'Người thực hiện',
    key: 'assignee',
    sorter: true,
    dataIndex: 'assignee',
  },
  {
    title: 'Yêu cầu số tán thành',
    key: 'ruleName',
    sorter: true,
    width: 150,
    dataIndex: 'ruleName',
  },
];
